module.exports = __webpack_public_path__ + "static/media/suburu_brz.f904af7a.webp";